const LandLease = () => {
  return (
    <>
      <h4 style={{ textAlign: "center" }}>नेपाल विश्वविद्यालय</h4>
      <h3 style={{ textAlign: "center" }}>
        घर जग्गा भाडामा दिनेबारे प्रस्ताव आह्वान
      </h3>
      <p style={{ textAlign: "center" }}>
        दोस्रो पटक प्रकाशन मिति: २०८२/०४/०६ (22nd July, 2025)
      </p>

      <br />

      <p>
        नेपाल विश्वविद्यालयलाई अन्तर्गत सञ्चालन गरिने शैक्षिक कार्यक्रमको लागि
        आवश्यक पर्ने भवन सहितको जग्गा वा अस्थायी संरचना बनाउन सहमति सहितको खाली
        जग्गा भाडामा उपलब्ध गराउन इच्छुक व्यक्ति, संस्था वा फर्महरूबाट प्रस्ताव
        आह्वान गरिएको छ। इच्छुकले तल उल्लेखित कागजात सहित यो सूचना प्रकाशित भएको
        मितिले ३० दिनभित्र विश्वविद्यालयको ठेगानामा प्रस्ताव पेस गर्नुपर्नेछ।
      </p>

      <ul>
        <li>
          <strong>जग्गा तथा भौतिक संरचनाको आवश्यकताः</strong>
          <ul>
            <li>भवन: न्यूनतम क्षेत्रफल १०,००० वर्ग फिट।</li>
            <li>जग्गा: कम्पाउण्डसहित कम्तीमा ५ रोपनी।</li>
            <li>प्रकार: भवनसहितको जग्गा वा खाली जग्गा मात्र।</li>
            <li>
              स्थान: यातायातको सुविधा भएको, चक्रपथ (रिङरोड) वा चक्रपथ बाहिर करिब
              १ कि.मि. दूरीमा भएकोलाई प्राथमिकता दिइनेछ।
            </li>
          </ul>
        </li>
      </ul>

      <ul>
        <li>
          <strong>प्रस्तावका साथ पेश गर्नुपर्ने कागजातहरू:</strong>
          <ul>
            <li>जग्गा धनी प्रमाण पुर्जा र सम्बन्धित नागरिकताको प्रतिलिपि।</li>
            <li>यदि भवनसहितको जग्गा भएमा भवनको विवरण खुल्ने कागजातहरू।</li>
            <li>अन्य सम्बन्धित कागजातहरू।</li>
          </ul>
        </li>
      </ul>

      <ul>
        <li>
          <strong>भाडा अवधि:</strong>
          <p>जग्गा तथा भौतिक संरचना न्यूनतम ५ वर्षका लागि भाडामा लिन सकिनेछ।</p>
        </li>
      </ul>

      <ul>
        <li>
          <strong>प्रस्ताव बुझाउने ठेगाना:</strong>
          <p>
            नेपाल विश्वविद्यालय <br />
            सानो गौचरन, ज्ञानेश्वर, काठमाडौं <br />
            कार्यालय सम्पर्क नं: ०१-५९१४५८८ <br />
            मोबाइल नं: ९८४१३३७२९९ <br />
            इमेल: <a href="mailto:info@uon.edu.np">info@uon.edu.np</a>
          </p>
        </li>
      </ul>
    </>
  );
};

export default LandLease;
